var _defs, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 341.14 315.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -11.04,
    y1: 308.59,
    x2: 358.63,
    y2: 2.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0034ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0043fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#006df6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00afec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00cfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#00e2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7.29,
    y1: 313.11,
    x2: 362.38,
    y2: 6.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 340.93,
    y1: 105.93,
    x2: 97.95,
    y2: 375.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 171.97,
    y1: 83.35,
    x2: 171.97,
    y2: 283.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 230.33,
    y1: 6.35,
    x2: -12.65,
    y2: 276.23,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m333.56,10.05c-16.84-18.59-58.78-10.52-109.31,16.99,12.02,5.3,23.18,12.18,33.18,20.43,24.6-13.87,42.41-19.06,48.37-12.48,6.02,6.65-1.11,24.16-17.71,47.65-6.75,9.55-15.06,20.08-24.71,31.29,5.99,13.27,9.35,27.98,9.35,43.48,0,.89-.05,1.78-.07,2.67,11.9-13.74,22.47-27.32,31.54-40.42,33.64-48.64,46.5-90.69,29.37-109.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 171.97,
    cy: 155.07,
    r: 33.23,
    transform: "translate(-59.28 167.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.11,269.52c-.67-4.39-1.12-9.55-1.12-15.65h0c-9.51,6.28-18.4,11.68-26.48,16.06-22.53,12.2-38.75,16.49-44.38,10.28-5.57-6.14.11-21.57,14.1-42.41-7.25-10.59-13.09-22.22-17.29-34.61C2.06,248.65-8.69,287.42,7.57,305.37c16.55,18.27,57.33,10.81,106.69-15.56,0,0-4.9-5.59-7.15-20.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m304.2,119.66c-9.06,13.1-19.63,26.68-31.54,40.42-1.42,57.25-48.24,103.23-105.83,103.23-2.97,0-5.91-.15-8.82-.39-6.62-.55-13.05-1.73-19.27-3.44v.03s1.04,5.8,4.91,12.96c-10.04,6.45-19.88,12.26-29.4,17.34,16.27,6.47,34,10.06,52.58,10.06,78.68,0,142.46-63.78,142.46-142.46,0-13.08-1.8-25.73-5.1-37.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m138.74,212.08c9.76,5.7,21.11,8.99,33.23,8.99,36.45,0,65.99-29.54,65.99-65.99s-29.54-65.99-65.99-65.99-64.9,28.49-65.94,64.03l-.05-.03v100.78h0c0,6.12.45,11.28,1.12,15.66,2.26,14.7,7.15,20.29,7.15,20.29,35.83,14.89,70.79,8.91,70.79,8.91-23.81-2.22-35.68-15.71-41.39-26.25-3.88-7.16-4.91-12.96-4.91-12.96v-47.43Zm33.23-90.24c18.35,0,33.23,14.88,33.23,33.23s-14.88,33.23-33.23,33.23-33.23-14.88-33.23-33.23,14.88-33.23,33.23-33.23Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m257.44,47.47c-10-8.25-21.16-15.13-33.18-20.43-17.57-7.75-36.98-12.08-57.42-12.08C88.16,14.96,24.38,78.74,24.38,157.42c0,16.02,2.68,31.4,7.56,45.77,4.2,12.39,10.04,24.02,17.29,34.61,4.4,6.43,9.32,12.46,14.69,18.07,4.25,4.44,10.99,5.38,16.29,2.27,3.53-2.07,7.17-4.29,10.91-6.65,3.36-2.12,5.41-5.83,5.41-9.8,0-3.09-1.23-6.07-3.45-8.23-8.05-7.79-14.74-16.8-20.03-26.89-6.76-12.87-10.94-27.29-11.88-42.6-.13-2.16-.22-4.34-.22-6.54,0-58.48,47.41-105.89,105.89-105.89,5.43,0,10.77.41,15.98,1.2,15.14,2.29,29.22,7.81,41.54,15.8,14.61,9.48,26.73,22.46,35.18,37.75.12-.14.25-.28.37-.42,9.25-10.51,17.31-20.42,24.02-29.52-7.48-10.79-16.39-20.52-26.5-28.86Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.e4e5718dd747eb4255d33176797b3ff0.svg";
export { ForwardRef as ReactComponent };